// extracted by mini-css-extract-plugin
module.exports = {"icon":"DisconnectedAgentsCounter__icon--A_","counter":"DisconnectedAgentsCounter__counter--DQ"};